import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Menu extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.menu_box}>
                <div className={styles.menu}>
                    <div className={styles.logo}>
                        <a href="//pit.ifeng.com" target="_blank">
                            <span />
                        </a>
                    </div>
                    <div className={styles.list}>
                        <ul>
                            {content.map((item, index) => (
                                <li key={index}>
                                    <a href={item.url} target="_blank" title={item.title}>
                                        {item.title}
                                        <br />
                                        <span>{item.name}</span>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Menu);
